package com.htmlagent.site.state

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.htmlagent.site.theme.Breakpoints
import kotlinx.browser.window
import org.w3c.dom.events.Event

/**
 * Whether the window is too narrow to hold the chat and the page side by side.
 *
 * The same threshold the stylesheet uses ([Breakpoints.BelowMd]), read from Kotlin because what
 * depends on it is not only paint: which pane is mounted on screen, and whether the button that
 * crosses between them exists at all. A button hidden with CSS is still a button the keyboard
 * reaches, so the decision has to be taken where the markup is written.
 *
 * The first value comes from `matches` during composition, not from an effect, so the very first
 * frame is already right; without that a phone would paint the desktop layout and reflow.
 */
@Composable
fun rememberNarrowScreen(): Boolean {
    val query = remember { window.matchMedia(Breakpoints.BelowMd) }
    var narrow by remember { mutableStateOf(query.matches) }

    DisposableEffect(query) {
        val onChange: (Event) -> Unit = { narrow = query.matches }
        query.addEventListener("change", onChange)
        onDispose { query.removeEventListener("change", onChange) }
    }

    return narrow
}
